// extracted by mini-css-extract-plugin
module.exports = {"btn-delete":"_3_1m51SecifnY_6jisu0Kn"};